var _jsxFileName = "/repo/packages/ippm/src/components/Headline/index.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Switch, Grid, Row } from '@sm/wds-react';
import { sanitizeString } from '@sm/utils';
import { PLAN_TYPES } from '../../constants/plans';
import { useConfiguredExperimentContext } from '../../utils/experimentContext';
import { useAppContext } from '../../utils/appContext';
import { logIPPMInteraction } from '../../utils/logger';
import EduVisibilityBanner from '../experiment/IG2072EduVisibility/EduVisibilityBanner';
import './Headline.scss';
var Headline = function Headline(_ref) {
  var onBackToSurveyClick = _ref.onBackToSurveyClick;
  var experimentsConfig = useConfiguredExperimentContext();
  var appContext = useAppContext();
  var getString = appContext.getString,
    toggleDisplayedPlanType = appContext.toggleDisplayedPlanType,
    displayedPlanType = appContext.displayedPlanType;
  var ACTIVE_COLOR = 'dark';
  var INACTIVE_COLOR = 'light-muted';
  var clickBackToSurvey = function clickBackToSurvey(evt) {
    if (evt.target.id === 'return-to-survey') {
      logIPPMInteraction('popup_close', 'return_to_survey_link');
      onBackToSurveyClick();
    }
  };
  var renderSwitch = function renderSwitch() {
    var leftPlanColor = displayedPlanType === PLAN_TYPES.INDIVIDUAL ? ACTIVE_COLOR : INACTIVE_COLOR;
    var rightPlanColor = displayedPlanType === PLAN_TYPES.TEAMS ? ACTIVE_COLOR : INACTIVE_COLOR;
    return /*#__PURE__*/React.createElement(Grid, {
      className: "wds-m-t-6 wds-m-b-4 header-switch-container",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Row, {
      className: "margin-auto grid-row-ie11",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "b",
      color: leftPlanColor,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 11
      }
    }, getString('individual_plans')), /*#__PURE__*/React.createElement("span", {
      className: "plan-switch-col wds-m-l-4 wds-m-r-4",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: toggleDisplayedPlanType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 13
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      component: "b",
      color: rightPlanColor,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 11
      }
    }, getString('team_plans'))));
  };
  var renderHeader = function renderHeader() {
    var _appContext$addedPaid;
    if ((_appContext$addedPaid = appContext.addedPaidFeatures) !== null && _appContext$addedPaid !== void 0 && _appContext$addedPaid.length) {
      return getString('your_survey_includes');
    }
    return getString('do_more');
  };
  var renderSubHeader = function renderSubHeader() {
    var _appContext$addedPaid2;
    if ((_appContext$addedPaid2 = appContext.addedPaidFeatures) !== null && _appContext$addedPaid2 !== void 0 && _appContext$addedPaid2.length) {
      return getString('choose_a_plan');
    }
    return getString('get_our_best');
  };
  return /*#__PURE__*/React.createElement(Grid, {
    className: "wds-m-t-1",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: "width-fixed margin-auto",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("header", {
    className: "wds-type--center width-fixed margin-auto",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "h2",
    className: "font-size-30 font-weight-medium",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 11
    }
  }, renderHeader()), /*#__PURE__*/React.createElement(Typography, {
    onClick: clickBackToSurvey,
    component: "h3",
    className: "font-weight-light subheader",
    variant: "cardTitle",
    dangerouslySetInnerHTML: {
      __html: sanitizeString(renderSubHeader())
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 11
    }
  }), appContext.eduDiscountAvailable && !experimentsConfig.IG2072_EDU_VISIBILITY && /*#__PURE__*/React.createElement(Typography, {
    component: "h3",
    className: "font-weight-light wds-p-t-2",
    variant: "cardTitle",
    dangerouslySetInnerHTML: {
      __html: sanitizeString(getString('edu_discount'))
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 15
    }
  })), renderSwitch(), appContext.eduDiscountAvailable && experimentsConfig.IG2072_EDU_VISIBILITY && appContext.displayedPlanType === 'INDIVIDUAL' && /*#__PURE__*/React.createElement(EduVisibilityBanner, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 13
    }
  })));
};
Headline.propTypes = {
  onBackToSurveyClick: PropTypes.func.isRequired
};
export default Headline;